/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { Setup5Component} from './setup_5.component';

export class Setup5Validation extends IValidator {

     constructor(private component: Setup5Component,private menuID:number) {
           super();
           this.listedParentCount   = this.component.data.eligibility.listedParentCount;
           this.certifyingParentCount = this.component.data.eligibility.certifyingParentCount;
           this.viewportScroller = this.component.viewportScroller;
    }

     private listedParentCount:number = 0;
     private certifyingParentCount:number = 0;
     private viewportScroller:ViewportScroller;
     private success: boolean;

     public validate(): boolean {

          this.success = true;

          if(this.component.eligibility.listedParentCount == null || 
               this.component.eligibility.listedParentCount == 0){
                    
               this.focus("parentCount","radio_parentCountRadio_0").error_invalidListedParentCount = "setup_5.emptyListedParentCount";

          }

          if(this.component.displayCertifyingParentQuestion() == true
               && (Util.isEmpty(this.component.eligibility.certifyingParentCount) || 
               this.component.eligibility.certifyingParentCount == 0)){
               
               this.focus("certifyingParentCount","radio_certifyingParentCountRadio_0").error_invalidCertifyingParentCount = "setup_5.emptyCertifyingParentCount";
          }

          if(this.component.eligibility.listedParentCount == 1 && 
               this.component.eligibility.isUnableToCertify === 'Y'){
               
               this.focus("parentCount","radio_parentCountRadio_0").error_invalidListedParentCount = "setup_5.invalidListedParentCount";
               
          }

          if(this.component.displayCertifyingParentQuestion() && ((this.component.eligibility.listedParentCount == 3 && this.component.eligibility.certifyingParentCount >=3) ||
               (this.component.eligibility.listedParentCount == 4 && this.component.eligibility.certifyingParentCount == 4))){
               
               this.focus("certifyingParentCount","radio_certifyingParentCountRadio_0").error_invalidCertifyingParentCount = "setup_5.invalidCertifyingParentCount";
               
          }

          return this.success;
     }

     private focus(tagId:string,ctrlId:string) : Setup5Component {
      if ( this.success ) {
           this.viewportScroller.scrollToAnchor(tagId);
           let ctrl = document.getElementById(ctrlId);
           ///console.log(ctrl);
           if ( ctrl ) ctrl.focus();
      }
           
      this.success = false;
      return this.component;
     }

     public IdOfChanged():number { 

          if (  this.listedParentCount !=  this.component.data.eligibility.listedParentCount ||
                this.certifyingParentCount !=  this.component.data.eligibility.certifyingParentCount) return this.menuID;

            return 0;
      }

}
